import { IconProps } from '@chakra-ui/react';
import some from 'lodash/some';

import {
  DocFileIcon,
  ExcelFileIcon,
  PDFFileIcon,
  PowerPointFileIcon,
} from './chakra/customIcon';
import {
  FileIcon,
  FileTextIcon,
  ImageIcon,
  PlayCircleIcon,
} from './chakra/feather';

type IFileTypeDisplayInfo = {
  typeDisplayName?: string;
  color: string;
  ChakraIcon: React.FC<IconProps>;
  previewDisabled?: boolean;
};

const fileTypeInfoRegexes: {
  info: IFileTypeDisplayInfo;
  regexes: RegExp[];
}[] = [
  {
    info: {
      typeDisplayName: 'Text',
      color: 'rgb(104, 106, 214)',
      ChakraIcon: FileTextIcon,
    },
    regexes: [/^text\//i],
  },
  {
    info: {
      typeDisplayName: 'Video',
      color: 'rgb(212, 101, 125)',
      ChakraIcon: PlayCircleIcon,
      previewDisabled: true,
    },
    regexes: [/^video\//i],
  },
  {
    info: {
      typeDisplayName: 'Audio',
      color: 'rgb(247, 183, 12)',
      ChakraIcon: PlayCircleIcon,
      previewDisabled: true,
    },
    regexes: [/^audio\//i],
  },
  {
    info: {
      typeDisplayName: 'Image',
      color: 'rgb(212, 153, 105)',
      ChakraIcon: ImageIcon,
    },
    regexes: [/^image\//i],
  },
  {
    info: {
      typeDisplayName: 'PDF Document',
      color: 'rgb(202, 0, 5)',
      ChakraIcon: PDFFileIcon,
    },
    regexes: [/^application\/(x-)?pdf$/i],
  },
  {
    info: {
      typeDisplayName: 'Word Document',
      color: 'rgb(51, 140, 223)',
      ChakraIcon: DocFileIcon,
    },
    regexes: [
      /^application\/[A-Za-z-\.]*msword$/i,
      /^application\/[A-Za-z-\.]*.wordprocessingml.document$/i,
    ],
  },
  {
    info: {
      typeDisplayName: 'PowerPoint Document',
      color: 'rgb(212, 67, 19)',
      ChakraIcon: PowerPointFileIcon,
    },
    regexes: [
      /^application\/[A-Za-z-\.]*powerpoint$/i,
      /^application\/[A-Za-z-\.]*presentationml.presentation$/i,
    ],
  },
  {
    info: {
      typeDisplayName: 'Excel Document',
      color: 'rgb(45, 178, 104)',
      ChakraIcon: ExcelFileIcon,
    },
    regexes: [
      /^application\/[A-Za-z-\.]*excel$/i,
      /^application\/[A-Za-z-\.]*spreadsheetml.sheet$/i,
    ],
  },
];

export const getFileTypeDisplayInfo = (
  itemType: string
): IFileTypeDisplayInfo => {
  for (let i = 0; i < fileTypeInfoRegexes.length; i++) {
    const infoRegex = fileTypeInfoRegexes[i];
    if (some(infoRegex.regexes, (regex) => regex.test(itemType))) {
      return infoRegex.info;
    }
  }
  return {
    color: 'rgb(104, 106, 214)',
    ChakraIcon: FileIcon,
    previewDisabled: true,
  };
};
